import React, { Fragment } from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    invoiceNoContainer: {
        flexDirection: 'row',
        marginTop: 5,
        width: '100%',
        justifyContent: 'center'
    },
    invoiceDateContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    invoiceDate: {
        fontSize: 12,
        fontWeight: 'bold',
        fontFamily: 'Helvetica-Bold',
    },
    fragmentContainer: {
        width: 200
    }
  });

  const ProposalNo = ({invoice}) => (
        <Fragment>
            <View style={styles.fragmentContainer}>
                <View style={styles.invoiceNoContainer}>
                    <Text style={styles.invoiceDate}>Proposta n°: {invoice.invoice_no}</Text>
                </View >
            </View >
        </Fragment>
  );
  
  export default ProposalNo